export default __webpack_public_path__ + "static/quiz-answer-fae50ae74c3f5bd48d04841e0cd0e230.jpg";